import { filter, get } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectKeyContacts = state => searchEntities(state, 'keyContacts', ['name', 'department', 'email', 'phone']);
